/* Autogenerated file. Do not edit manually. */

import type { BytesLike, JsonAbi } from 'fuels';

export const generationDate = 1725479113004;
// biome-ignore lint: Autogenerated file
export const abi: JsonAbi = {
  programType: 'predicate',
  specVersion: '1',
  encodingVersion: '1',
  concreteTypes: [
    {
      type: 'b256',
      concreteTypeId:
        '7c5ee1cecf5f8eacd1284feb5f0bf2bdea533a51e2f0c9aabe9236d335989f3b',
    },
    {
      type: 'bool',
      concreteTypeId:
        'b760f44fa5965c2474a3b471467a22c43185152129295af588b022ae50b50903',
    },
    {
      type: 'u64',
      concreteTypeId:
        '1506e6f44c1d6291cdf46395a8e573276a4fa79e8ace3fc891e092ef32d1b0a0',
    },
  ],
  metadataTypes: [],
  functions: [
    {
      inputs: [
        {
          name: 'witness_index',
          concreteTypeId:
            '1506e6f44c1d6291cdf46395a8e573276a4fa79e8ace3fc891e092ef32d1b0a0',
        },
      ],
      name: 'main',
      output:
        'b760f44fa5965c2474a3b471467a22c43185152129295af588b022ae50b50903',
      attributes: null,
    },
  ],
  loggedTypes: [],
  messagesTypes: [],
  configurables: [
    {
      name: 'SIGNER',
      concreteTypeId:
        '7c5ee1cecf5f8eacd1284feb5f0bf2bdea533a51e2f0c9aabe9236d335989f3b',
      offset: 3136,
    },
  ],
};
export const bin: BytesLike = new Uint8Array([
  26, 240, 48, 0, 116, 0, 0, 2, 0, 0, 0, 0, 0, 0, 12, 64, 93, 255, 192, 1, 16,
  255, 255, 0, 145, 0, 0, 32, 80, 235, 240, 0, 80, 228, 0, 32, 80, 224, 64, 0,
  32, 248, 51, 0, 88, 251, 224, 2, 80, 251, 224, 4, 116, 0, 0, 20, 26, 236, 80,
  0, 113, 64, 0, 3, 97, 69, 2, 0, 19, 73, 16, 0, 118, 72, 0, 6, 114, 72, 0, 2,
  19, 69, 20, 128, 118, 68, 0, 1, 54, 0, 0, 0, 97, 65, 2, 74, 116, 0, 0, 1, 97,
  65, 2, 12, 93, 65, 0, 0, 26, 233, 0, 0, 32, 248, 51, 0, 88, 251, 224, 2, 80,
  251, 224, 4, 116, 0, 0, 26, 26, 67, 208, 0, 36, 64, 0, 0, 149, 0, 0, 15, 150,
  8, 0, 0, 26, 236, 80, 0, 145, 0, 0, 96, 26, 67, 160, 0, 26, 75, 128, 0, 26,
  79, 224, 0, 114, 68, 0, 32, 40, 237, 4, 64, 80, 67, 176, 64, 114, 68, 0, 32,
  40, 67, 180, 64, 80, 71, 176, 32, 114, 64, 0, 32, 40, 71, 180, 0, 80, 67, 176,
  32, 114, 68, 0, 32, 40, 73, 4, 64, 26, 244, 0, 0, 146, 0, 0, 96, 26, 249, 48,
  0, 152, 8, 0, 0, 151, 0, 0, 15, 74, 248, 0, 0, 149, 0, 1, 255, 150, 8, 0, 0,
  26, 236, 80, 0, 145, 0, 10, 56, 26, 67, 160, 0, 26, 87, 224, 0, 97, 68, 0, 1,
  19, 73, 16, 0, 118, 72, 0, 5, 19, 69, 16, 64, 118, 68, 0, 1, 54, 0, 0, 0, 26,
  68, 16, 0, 116, 0, 0, 1, 26, 68, 0, 0, 19, 73, 16, 0, 118, 72, 0, 6, 19, 69,
  16, 64, 118, 68, 0, 2, 93, 67, 240, 12, 54, 64, 0, 0, 97, 68, 1, 5, 116, 0, 0,
  1, 97, 68, 0, 7, 21, 73, 4, 64, 118, 72, 0, 1, 19, 73, 4, 64, 118, 72, 0, 20,
  80, 71, 178, 248, 95, 236, 16, 95, 97, 65, 4, 1, 80, 75, 181, 80, 26, 233, 0,
  0, 26, 229, 32, 0, 32, 248, 51, 0, 88, 251, 224, 2, 80, 251, 224, 4, 116, 0,
  1, 8, 26, 67, 208, 0, 114, 72, 0, 64, 40, 237, 4, 128, 80, 65, 16, 8, 114, 72,
  0, 64, 40, 67, 180, 128, 80, 75, 182, 240, 114, 64, 0, 72, 40, 73, 20, 0, 116,
  0, 0, 5, 80, 67, 177, 0, 95, 236, 0, 32, 80, 75, 182, 240, 114, 68, 0, 72, 40,
  73, 4, 64, 80, 67, 181, 8, 114, 68, 0, 72, 40, 65, 36, 64, 93, 67, 176, 222,
  19, 65, 0, 64, 118, 64, 0, 1, 54, 0, 0, 0, 93, 67, 240, 13, 16, 65, 0, 192,
  93, 71, 240, 14, 16, 69, 16, 192, 93, 95, 240, 15, 16, 93, 112, 192, 80, 75,
  181, 8, 80, 73, 32, 8, 80, 79, 184, 104, 114, 80, 0, 64, 40, 77, 37, 0, 80,
  79, 185, 248, 114, 80, 0, 64, 40, 77, 37, 0, 80, 91, 185, 248, 26, 72, 0, 0,
  80, 79, 176, 64, 114, 80, 0, 32, 40, 77, 37, 0, 80, 75, 177, 208, 114, 80, 0,
  32, 40, 73, 53, 0, 80, 77, 32, 32, 114, 80, 0, 32, 40, 77, 5, 0, 80, 65, 32,
  64, 114, 76, 0, 32, 40, 65, 20, 192, 80, 67, 184, 8, 114, 68, 0, 96, 40, 65,
  36, 64, 80, 99, 184, 8, 80, 67, 183, 232, 114, 68, 0, 32, 40, 65, 116, 64, 80,
  67, 183, 232, 114, 68, 0, 60, 16, 69, 132, 64, 80, 75, 184, 8, 80, 73, 32, 32,
  114, 76, 0, 32, 114, 80, 0, 60, 40, 69, 132, 192, 65, 65, 37, 0, 80, 67, 183,
  232, 80, 71, 177, 144, 114, 72, 0, 32, 27, 72, 4, 128, 16, 73, 20, 128, 114,
  76, 0, 32, 40, 73, 116, 192, 114, 72, 0, 32, 27, 72, 20, 128, 16, 73, 20, 128,
  114, 76, 0, 32, 40, 73, 116, 192, 80, 75, 178, 120, 114, 76, 0, 64, 40, 73,
  20, 192, 80, 71, 185, 144, 114, 76, 0, 64, 40, 69, 36, 192, 80, 71, 185, 144,
  80, 75, 180, 48, 114, 76, 0, 32, 40, 73, 4, 192, 62, 69, 100, 128, 26, 64,
  128, 0, 19, 65, 0, 64, 118, 64, 0, 10, 80, 67, 179, 128, 95, 236, 0, 112, 80,
  71, 185, 144, 80, 73, 0, 8, 114, 76, 0, 64, 40, 73, 20, 192, 80, 75, 183, 56,
  114, 68, 0, 72, 40, 73, 4, 64, 116, 0, 0, 6, 80, 67, 177, 72, 95, 236, 16, 41,
  95, 236, 0, 49, 80, 75, 183, 56, 114, 68, 0, 72, 40, 73, 4, 64, 80, 67, 185,
  40, 114, 68, 0, 72, 40, 65, 36, 64, 80, 67, 180, 80, 114, 68, 0, 72, 40, 65,
  36, 64, 93, 67, 176, 231, 19, 65, 0, 64, 118, 64, 0, 96, 80, 67, 185, 40, 80,
  71, 180, 152, 114, 72, 0, 72, 40, 69, 4, 128, 93, 67, 177, 37, 19, 65, 0, 0,
  118, 64, 0, 1, 54, 0, 0, 0, 80, 67, 180, 152, 80, 65, 0, 8, 80, 71, 184, 168,
  114, 72, 0, 64, 40, 69, 4, 128, 80, 71, 182, 112, 114, 72, 0, 64, 40, 69, 4,
  128, 80, 75, 181, 176, 26, 233, 16, 0, 26, 229, 32, 0, 32, 248, 51, 0, 88,
  251, 224, 2, 80, 251, 224, 4, 116, 0, 2, 22, 26, 71, 208, 0, 80, 75, 176, 96,
  114, 76, 0, 64, 40, 73, 20, 192, 80, 71, 178, 184, 114, 76, 0, 64, 40, 69, 36,
  192, 80, 71, 182, 176, 114, 72, 0, 64, 40, 69, 4, 128, 80, 67, 181, 240, 26,
  233, 16, 0, 26, 229, 0, 0, 32, 248, 51, 0, 88, 251, 224, 2, 80, 251, 224, 4,
  116, 0, 2, 5, 26, 67, 208, 0, 80, 71, 176, 160, 114, 72, 0, 64, 40, 69, 4,
  128, 80, 67, 179, 64, 114, 72, 0, 64, 40, 65, 20, 128, 80, 67, 179, 200, 80,
  71, 176, 96, 114, 72, 0, 32, 27, 72, 4, 128, 16, 73, 20, 128, 114, 68, 0, 32,
  40, 65, 36, 64, 80, 69, 0, 32, 80, 75, 176, 160, 114, 76, 0, 32, 27, 76, 20,
  192, 16, 77, 36, 192, 114, 72, 0, 32, 40, 69, 52, 128, 80, 71, 182, 48, 114,
  72, 0, 64, 40, 69, 4, 128, 80, 67, 181, 144, 26, 233, 16, 0, 26, 229, 0, 0,
  32, 248, 51, 0, 88, 251, 224, 2, 80, 251, 224, 4, 116, 0, 0, 93, 26, 67, 208,
  0, 80, 71, 176, 224, 114, 72, 0, 32, 40, 69, 4, 128, 80, 67, 185, 112, 114,
  72, 0, 32, 40, 65, 20, 128, 80, 67, 180, 8, 95, 236, 0, 129, 80, 75, 185, 8,
  114, 76, 0, 32, 40, 73, 20, 192, 80, 71, 185, 8, 112, 68, 0, 12, 80, 71, 185,
  8, 80, 75, 178, 48, 114, 76, 0, 32, 40, 73, 20, 192, 80, 69, 0, 8, 114, 76, 0,
  32, 40, 69, 36, 192, 80, 75, 183, 128, 114, 68, 0, 40, 40, 73, 4, 64, 116, 0,
  0, 10, 80, 67, 180, 80, 80, 65, 0, 64, 80, 71, 178, 80, 95, 236, 16, 74, 80,
  73, 16, 32, 114, 76, 0, 8, 40, 73, 4, 192, 80, 75, 183, 128, 114, 64, 0, 40,
  40, 73, 20, 0, 80, 67, 185, 208, 114, 68, 0, 40, 40, 65, 36, 64, 93, 67, 176,
  240, 19, 65, 0, 0, 26, 68, 16, 0, 118, 64, 0, 1, 26, 68, 0, 0, 118, 68, 0, 1,
  116, 0, 0, 23, 80, 64, 64, 0, 80, 71, 185, 208, 80, 75, 180, 224, 114, 76, 0,
  40, 40, 73, 20, 192, 93, 71, 177, 58, 19, 69, 16, 0, 118, 68, 0, 1, 54, 0, 0,
  0, 80, 71, 180, 224, 80, 69, 16, 8, 80, 75, 184, 232, 114, 76, 0, 32, 40, 73,
  20, 192, 80, 71, 184, 232, 80, 75, 183, 168, 114, 76, 0, 32, 40, 73, 4, 192,
  80, 67, 183, 200, 114, 76, 0, 32, 40, 65, 20, 192, 161, 65, 36, 32, 118, 64,
  0, 2, 26, 244, 0, 0, 116, 0, 0, 1, 26, 244, 16, 0, 146, 0, 10, 56, 26, 249,
  80, 0, 152, 8, 0, 0, 151, 0, 1, 255, 74, 248, 0, 0, 149, 0, 0, 15, 150, 8, 0,
  0, 26, 236, 80, 0, 145, 0, 0, 64, 26, 67, 160, 0, 26, 71, 144, 0, 26, 75, 224,
  0, 114, 76, 0, 64, 40, 237, 4, 192, 114, 64, 0, 64, 40, 71, 180, 0, 26, 245,
  16, 0, 146, 0, 0, 64, 26, 249, 32, 0, 152, 8, 0, 0, 151, 0, 0, 15, 74, 248, 0,
  0, 149, 0, 0, 127, 150, 8, 0, 0, 26, 236, 80, 0, 145, 0, 0, 200, 26, 67, 160,
  0, 26, 71, 144, 0, 26, 75, 224, 0, 93, 79, 240, 16, 16, 77, 48, 192, 26, 80,
  0, 0, 38, 80, 0, 0, 26, 80, 112, 0, 95, 237, 64, 18, 95, 236, 0, 19, 95, 236,
  0, 20, 80, 83, 176, 144, 80, 87, 176, 32, 114, 88, 0, 64, 40, 85, 5, 128, 26,
  233, 80, 0, 26, 229, 64, 0, 32, 248, 51, 0, 88, 251, 224, 2, 80, 251, 224, 4,
  116, 0, 0, 34, 80, 67, 176, 144, 80, 83, 176, 168, 114, 84, 0, 32, 40, 81, 53,
  64, 80, 79, 176, 168, 80, 83, 176, 120, 114, 84, 0, 24, 40, 81, 5, 64, 26,
  233, 64, 0, 32, 248, 51, 0, 88, 251, 224, 2, 80, 251, 224, 4, 116, 0, 1, 79,
  26, 83, 208, 0, 80, 87, 176, 96, 114, 88, 0, 24, 40, 85, 5, 128, 26, 233, 80,
  0, 32, 248, 51, 0, 88, 251, 224, 2, 80, 251, 224, 4, 116, 0, 0, 222, 26, 67,
  208, 0, 65, 77, 68, 0, 114, 64, 0, 32, 40, 237, 52, 0, 114, 64, 0, 32, 40, 71,
  180, 0, 26, 245, 16, 0, 146, 0, 0, 200, 26, 249, 32, 0, 152, 8, 0, 0, 151, 0,
  0, 127, 74, 248, 0, 0, 149, 0, 0, 31, 150, 8, 0, 0, 26, 236, 80, 0, 145, 0, 0,
  64, 26, 67, 160, 0, 26, 71, 144, 0, 26, 75, 224, 0, 114, 76, 0, 32, 40, 237,
  4, 192, 26, 235, 176, 0, 26, 229, 16, 0, 32, 248, 51, 0, 88, 251, 224, 2, 80,
  251, 224, 4, 116, 0, 0, 16, 80, 65, 0, 32, 80, 79, 176, 32, 114, 80, 0, 32,
  40, 77, 5, 0, 26, 233, 48, 0, 26, 229, 16, 0, 32, 248, 51, 0, 88, 251, 224, 2,
  80, 251, 224, 4, 116, 0, 0, 6, 26, 244, 0, 0, 146, 0, 0, 64, 26, 249, 32, 0,
  152, 8, 0, 0, 151, 0, 0, 31, 74, 248, 0, 0, 149, 0, 3, 255, 150, 8, 0, 0, 26,
  236, 80, 0, 145, 0, 1, 88, 26, 67, 160, 0, 26, 91, 144, 0, 26, 87, 224, 0,
  114, 68, 0, 32, 38, 68, 0, 0, 26, 68, 112, 0, 80, 75, 176, 72, 114, 76, 0, 32,
  40, 73, 4, 192, 93, 65, 32, 0, 93, 77, 32, 1, 93, 81, 32, 2, 93, 73, 32, 3,
  95, 69, 0, 0, 95, 69, 48, 1, 95, 69, 64, 2, 95, 69, 32, 3, 80, 67, 176, 104,
  26, 233, 16, 0, 114, 68, 0, 32, 26, 229, 16, 0, 26, 225, 0, 0, 32, 248, 51, 0,
  88, 251, 224, 2, 80, 251, 224, 4, 116, 0, 0, 171, 26, 67, 208, 0, 80, 71, 176,
  16, 114, 72, 0, 16, 40, 69, 4, 128, 114, 72, 0, 16, 40, 237, 4, 128, 80, 67,
  177, 0, 114, 72, 0, 16, 40, 67, 180, 128, 80, 75, 176, 136, 26, 233, 0, 0, 26,
  229, 32, 0, 32, 248, 51, 0, 88, 251, 224, 2, 80, 251, 224, 4, 116, 0, 0, 187,
  26, 67, 208, 0, 93, 73, 0, 0, 93, 65, 0, 1, 80, 79, 177, 32, 114, 80, 0, 16,
  40, 77, 21, 0, 26, 233, 48, 0, 32, 248, 51, 0, 88, 251, 224, 2, 80, 251, 224,
  4, 116, 0, 0, 210, 26, 71, 208, 0, 80, 95, 176, 48, 95, 237, 32, 6, 95, 237,
  0, 7, 95, 237, 16, 8, 80, 67, 176, 168, 114, 68, 0, 24, 40, 65, 116, 64, 26,
  233, 0, 0, 32, 248, 51, 0, 88, 251, 224, 2, 80, 251, 224, 4, 116, 0, 0, 109,
  26, 99, 208, 0, 19, 65, 128, 0, 118, 64, 0, 100, 93, 65, 96, 2, 19, 65, 0, 0,
  118, 64, 0, 95, 93, 65, 96, 2, 16, 101, 6, 0, 93, 65, 96, 2, 80, 71, 176, 192,
  114, 72, 0, 16, 40, 69, 100, 128, 26, 233, 16, 0, 32, 248, 51, 0, 88, 251,
  224, 2, 80, 251, 224, 4, 116, 0, 0, 103, 26, 71, 208, 0, 22, 69, 22, 64, 118,
  68, 0, 1, 116, 0, 0, 58, 80, 71, 176, 224, 114, 72, 0, 16, 40, 69, 100, 128,
  26, 233, 16, 0, 32, 248, 51, 0, 88, 251, 224, 2, 80, 251, 224, 4, 116, 0, 0,
  123, 26, 71, 208, 0, 80, 75, 176, 208, 114, 76, 0, 16, 40, 73, 100, 192, 26,
  233, 32, 0, 32, 248, 51, 0, 88, 251, 224, 2, 80, 251, 224, 4, 116, 0, 0, 82,
  26, 75, 208, 0, 21, 77, 148, 128, 26, 81, 16, 0, 118, 76, 0, 1, 116, 0, 0, 6,
  38, 100, 0, 0, 26, 80, 112, 0, 21, 77, 32, 0, 118, 76, 0, 1, 116, 0, 0, 1, 40,
  81, 20, 128, 80, 71, 176, 120, 26, 233, 64, 0, 26, 229, 144, 0, 26, 225, 16,
  0, 32, 248, 51, 0, 88, 251, 224, 2, 80, 251, 224, 4, 116, 0, 0, 74, 26, 71,
  208, 0, 80, 75, 176, 32, 114, 76, 0, 16, 40, 73, 20, 192, 80, 71, 177, 72,
  114, 76, 0, 16, 40, 69, 36, 192, 80, 71, 177, 16, 114, 76, 0, 16, 40, 69, 36,
  192, 80, 75, 176, 152, 26, 233, 16, 0, 26, 229, 32, 0, 32, 248, 51, 0, 88,
  251, 224, 2, 80, 251, 224, 4, 116, 0, 0, 89, 26, 71, 208, 0, 93, 73, 16, 0,
  93, 69, 16, 1, 95, 89, 32, 0, 95, 89, 16, 1, 80, 71, 176, 240, 114, 72, 0, 16,
  40, 69, 100, 128, 26, 233, 16, 0, 32, 248, 51, 0, 88, 251, 224, 2, 80, 251,
  224, 4, 116, 0, 0, 65, 26, 71, 208, 0, 16, 65, 20, 0, 80, 71, 177, 48, 114,
  72, 0, 24, 40, 69, 116, 128, 26, 233, 16, 0, 32, 248, 51, 0, 88, 251, 224, 2,
  80, 251, 224, 4, 116, 0, 0, 116, 26, 71, 208, 0, 40, 65, 22, 0, 95, 89, 144,
  2, 116, 0, 0, 2, 114, 64, 0, 24, 40, 89, 116, 0, 26, 244, 0, 0, 146, 0, 1, 88,
  26, 249, 80, 0, 152, 8, 0, 0, 151, 0, 3, 255, 74, 248, 0, 0, 149, 0, 0, 3,
  150, 8, 0, 0, 26, 236, 80, 0, 26, 67, 160, 0, 26, 71, 224, 0, 93, 65, 0, 2,
  26, 245, 0, 0, 26, 249, 16, 0, 152, 8, 0, 0, 151, 0, 0, 3, 74, 248, 0, 0, 149,
  0, 0, 3, 150, 8, 0, 0, 26, 236, 80, 0, 26, 67, 160, 0, 26, 71, 224, 0, 93, 65,
  0, 1, 26, 245, 0, 0, 26, 249, 16, 0, 152, 8, 0, 0, 151, 0, 0, 3, 74, 248, 0,
  0, 149, 0, 0, 31, 150, 8, 0, 0, 26, 236, 80, 0, 145, 0, 0, 32, 26, 67, 160, 0,
  26, 71, 144, 0, 26, 75, 128, 0, 26, 79, 224, 0, 80, 83, 176, 16, 95, 237, 0,
  2, 95, 237, 16, 3, 114, 64, 0, 16, 40, 237, 68, 0, 114, 64, 0, 16, 40, 75,
  180, 0, 26, 245, 32, 0, 146, 0, 0, 32, 26, 249, 48, 0, 152, 8, 0, 0, 151, 0,
  0, 31, 74, 248, 0, 0, 149, 0, 0, 3, 150, 8, 0, 0, 26, 236, 80, 0, 26, 67, 160,
  0, 26, 71, 224, 0, 93, 65, 0, 0, 26, 245, 0, 0, 26, 249, 16, 0, 152, 8, 0, 0,
  151, 0, 0, 3, 74, 248, 0, 0, 149, 0, 0, 63, 150, 8, 0, 0, 26, 236, 80, 0, 145,
  0, 0, 32, 26, 67, 160, 0, 26, 71, 144, 0, 26, 75, 224, 0, 80, 79, 176, 16,
  114, 80, 0, 16, 40, 77, 5, 0, 26, 233, 48, 0, 32, 248, 51, 0, 88, 251, 224, 2,
  80, 251, 224, 4, 116, 0, 0, 19, 26, 79, 208, 0, 38, 76, 0, 0, 26, 80, 112, 0,
  21, 85, 48, 0, 118, 84, 0, 1, 116, 0, 0, 5, 114, 84, 0, 16, 40, 237, 5, 64,
  26, 67, 176, 0, 93, 65, 0, 0, 40, 81, 4, 192, 95, 69, 64, 0, 95, 69, 48, 1,
  26, 245, 16, 0, 146, 0, 0, 32, 26, 249, 32, 0, 152, 8, 0, 0, 151, 0, 0, 63,
  74, 248, 0, 0, 149, 0, 0, 7, 150, 8, 0, 0, 26, 236, 80, 0, 145, 0, 0, 16, 26,
  67, 160, 0, 26, 71, 224, 0, 114, 72, 0, 16, 40, 237, 4, 128, 26, 67, 176, 0,
  93, 65, 0, 1, 26, 245, 0, 0, 146, 0, 0, 16, 26, 249, 16, 0, 152, 8, 0, 0, 151,
  0, 0, 7, 74, 248, 0, 0, 149, 0, 0, 7, 150, 8, 0, 0, 26, 236, 80, 0, 145, 0, 0,
  16, 26, 67, 160, 0, 26, 71, 224, 0, 114, 72, 0, 16, 40, 237, 4, 128, 26, 235,
  176, 0, 32, 248, 51, 0, 88, 251, 224, 2, 80, 251, 224, 4, 117, 0, 0, 72, 26,
  67, 208, 0, 26, 245, 0, 0, 146, 0, 0, 16, 26, 249, 16, 0, 152, 8, 0, 0, 151,
  0, 0, 7, 74, 248, 0, 0, 149, 0, 0, 15, 150, 8, 0, 0, 26, 236, 80, 0, 26, 67,
  160, 0, 26, 71, 144, 0, 26, 75, 224, 0, 114, 76, 0, 64, 40, 69, 4, 192, 26,
  245, 16, 0, 26, 249, 32, 0, 152, 8, 0, 0, 151, 0, 0, 15, 74, 248, 0, 0, 71, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 25, 69, 116, 104, 101, 114, 101, 117, 109, 32, 83,
  105, 103, 110, 101, 100, 32, 77, 101, 115, 115, 97, 103, 101, 58, 10, 51, 50,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 204, 204, 204, 204, 204, 204, 0, 2, 0, 0, 0, 0,
  0, 0, 10, 132, 0, 0, 0, 0, 0, 0, 10, 156, 0, 0, 0, 0, 0, 0, 10, 148, 0, 0, 0,
  0, 0, 0, 6, 124,
]);
